import React from 'react'
import styled from 'styled-components'

import { NavQuizzesDueBadge } from './NavQuizzesDueBadge'

type NavMultilineLabelProps = {
  badgeLabel?: string
  lines: [string, string]
}

const NavMultilineLabel = ({
  badgeLabel,
  lines
}: NavMultilineLabelProps): JSX.Element => (
  <MultilineLabel>
    <LabelLine>
      {lines[0]}
      {badgeLabel ? (
        <NavQuizzesDueBadge
          $inline
          aria-label={`${badgeLabel} quizzes due today`}
        >
          {badgeLabel}
        </NavQuizzesDueBadge>
      ) : null}
    </LabelLine>
    <LabelLine>{lines[1]}</LabelLine>
  </MultilineLabel>
)

export default NavMultilineLabel

const MultilineLabel = styled.span`
  display: flex;
  flex-direction: column;
  line-height: 16px;
  white-space: normal;
`

const LabelLine = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 0;
`
